// Owner 2026-11-01: Auto slider follows actual WIN stake, not Punter's separate Paper budget.
import React, { useEffect, useState } from 'react';
type Req = (path: string, body?: any, signal?: AbortSignal) => Promise<any>;
const P = '/api/rolling/simple-bsp/win-stake-control';
const L = '/api/rolling/simple-bsp/lay-risk-control';
const money = (n: number) => '$' + Math.round(n || 0).toLocaleString('en-AU');
const pct = (n: number) => n.toFixed(1) + '%';
export default function PunterStakeCompact({ request }: { request: Req }) {
  const [d, setD] = useState<any>(null), [busy, setBusy] = useState(false);
  const [lay, setLay] = useState<any>(null), [layBusy, setLayBusy] = useState(false);
  const [layDraft, setLayDraft] = useState<number | null>(null), [layError, setLayError] = useState('');
  const [err, setErr] = useState(''), [draft, setDraft] = useState<number | null>(null);
  const load = () => { request(P).then((x: any) => { setD(x); setErr(''); }).catch((e: any) => setErr(e.message));
    request(L).then((x: any) => { setLay(x); setLayError(''); }).catch((e: any) => setLayError(e.message)); };
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!d) return <div className="psc"><strong>Auto WIN staking</strong> {err ? <span role="alert">{err}</span> : '?'}</div>;
  const bank = Number(d.bank) || 0, actual = Number(d.stake) || 0;
  const percent = Number(d.percent) || 0;
  const show = draft ?? percent;
  const stakeFor = (p: number) => Math.max(10, Math.round(bank * p / 100));
  async function save(p: number) {
    p = Math.min(15, Math.max(0.5, Math.round(p * 10) / 10));
    if (Math.abs(p - percent) < 0.03) { setDraft(null); return; }
    if (p > percent && !window.confirm(`Increase default Auto WIN staking to ${money(stakeFor(p))} per bet (${pct(p)} of the bank)? This affects real-money bets not yet sent.`)) { setDraft(null); return; }
    setBusy(true); setErr('');
    try { setD(await request(P, { percent: p })); }
    catch (e: any) { setErr(e.message); }
    finally { setBusy(false); setDraft(null); }
  }
  async function saveLay(p: number) {
    if (!lay) return;
    p = Math.min(50, Math.max(0.5, Math.round(p * 10) / 10));
    if (Math.abs(p - Number(lay.percent)) < 0.03) { setLayDraft(null); return; }
    const newRisk = Math.max(10,Math.round(Number(lay.bank)*p/100));
    if (p > Number(lay.percent) && !window.confirm('Increase maximum Auto LAY loss to '+money(newRisk)+' per bet ('+pct(p)+' of bank)?')) {setLayDraft(null);return;}
    setLayBusy(true);setLayError('');
    try {setLay(await request(L,{percent:p}));}catch(e:any){setLayError(e.message);}
    finally{setLayBusy(false);setLayDraft(null);}
  }
  const presets = [1, 2, 4, 6, 8, 10, 15];
  const layPresets = [1, 2, 4, 6, 8, 10, 15, 20, 25, 35, 50];
  return <div className="psc" role="group" aria-label="Auto WIN staking">
    <div className="psc-now"><span>Default Auto WIN stake</span><strong>{draft == null ? money(actual) : money(stakeFor(show))}<small> a bet</small></strong>
      <em>{pct(show)} of the {money(bank)} sizing bank per bet ? maximum 15%</em></div>
    <div className="psc-presets">{presets.map(p => <button type="button" key={p} disabled={busy || bank <= 0}
      className={Math.abs(p - percent) < 0.05 ? 'psc-on' : ''} onClick={() => save(p)}>{pct(p)}</button>)}</div>
    <input type="range" min={0.5} max={15} step={0.1} value={show} disabled={busy || bank <= 0}
      aria-label="Auto WIN stake percentage of bank"
      onChange={e => setDraft(Number(e.target.value))}
      onMouseUp={() => draft != null && save(draft)}
      onTouchEnd={() => draft != null && save(draft)}
      onKeyUp={() => draft != null && save(draft)} />
    <small>Changes the default Auto WIN stake. Punter's separate Paper settings are unaffected. Manually edited and submitted stakes are preserved.</small>
    {err && <small role="alert" className="ins-neg">{err}</small>}
    {lay && <div role="group" aria-label="Auto LAY risk control" style={{borderTop:'1px solid #d7dce3',marginTop:16,paddingTop:14}}>
      <div className="psc-now"><span>Default Auto LAY ? maximum loss</span>
        <strong>{layDraft==null?money(Number(lay.risk)):money(Math.max(10,Math.round(Number(lay.bank)*(layDraft||0)/100)))}
          <small> at risk</small></strong>
        <em>{pct(layDraft??Number(lay.percent))} of the {money(Number(lay.bank))} bank. Independent of WIN staking.</em>
      </div>
      <div className="psc-presets">{layPresets.map(p=><button type="button" key={p} disabled={layBusy||!(Number(lay.bank)>0)}
        className={Math.abs(p-Number(lay.percent))<0.05?'psc-on':''} onClick={()=>saveLay(p)}>{pct(p)}</button>)}</div>
      <input type="range" min={0.5} max={50} step={0.1} value={layDraft??Number(lay.percent)}
        disabled={layBusy||!(Number(lay.bank)>0)} aria-label="Auto LAY maximum loss as percent of bank"
        onChange={e=>setLayDraft(Number(e.target.value))}
        onMouseUp={()=>layDraft!=null&&saveLay(layDraft)}
        onTouchEnd={()=>layDraft!=null&&saveLay(layDraft)}
        onKeyUp={()=>layDraft!=null&&saveLay(layDraft)}/>
      <small>Risk is the maximum possible loss, not the amount you could win. Existing BSP lays use fixed liability; realised lay stake depends on the BSP price.</small>
    </div>}
    {layError && <small role="alert" className="ins-neg">{layError}</small>}
  </div>;
}
